import { GuestModel, GuestPreferenceStatModel } from 'api-hooks/guest';
import { Option } from 'baseui/select';
import { Input } from 'components/elements';
import CustomFormControl from 'components/elements/custom-form-control';
import Text from 'components/elements/text';
import PreferenceMultiInput from 'legacy-modules/master/preference-tag/components/preference-multi-input';
import {
  CardSection,
  FullContainer,
  SeparatorVertical,
} from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

interface Props {
  guest?: GuestModel;
}

function bookingTransformer(item: GuestPreferenceStatModel): Option {
  return {
    id: item.id,
    label: `${item.name} ${item.count > 1 ? `(X${item.count})` : ''}`,
  };
}

export default function GuestPreferenceCard(props: Props) {
  const { t } = useTranslation();
  const { guest } = props;

  const bookingPreferences = React.useMemo(() => {
    if (guest) {
      return guest.preferenceStats.map((ps) => bookingTransformer(ps));
    }
    return [];
  }, [guest]);

  return (
    <CardSection>
      <Text variant="HeadingXSmall">{t('guest:guest_preferences')}</Text>
      <SeparatorVertical $margin={16} />
      <FullContainer>
        <PreferenceMultiInput
          name="preferences"
          label={t('guest:guest_specific_preferences')}
          placeholder={t('guest:guest_specific_preferences')}
          type="guest"
        />
        {guest && (
          <CustomFormControl
            label={t('guest:booking_preferences')}
            disabled
            noMargin
          >
            <Input
              type="select"
              name=""
              value={bookingPreferences}
              options={bookingPreferences}
              placeholder={t('common:empty')}
              multi
              disabled
            />
          </CustomFormControl>
        )}
      </FullContainer>
    </CardSection>
  );
}
